// Klaviyo integration script from Consentmo GDPR app
function checkConsentForKlaviyo(isMarketingEnabled) {
  if (isMarketingEnabled) {
    console.log('exec klaviyo');
    document.cookie = '__kla_off=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  } else {
    console.log('blocked klaviyo');
    document.cookie = '__kla_off=true';
  }
}

document.addEventListener('consentmoSignal_onLoad', function (eventData) {
  var csmLoadSignal = eventData.detail || { isActive: false };

  if (!csmLoadSignal.isActive) {
    checkConsentForKlaviyo(true);
  } else {
    document.addEventListener('consentmoSignal', function (event) {
      var csmPreferences = event.detail.preferences;
      checkConsentForKlaviyo(csmPreferences.marketing);
    });
  }
});

